import { menuItemsMakers } from "./menuItemsMakers";
export const menuItemsAcademics = [
  // {
  //   "children": [
  //     {
  //       "children": [
  //          {
  //         "children": [
  //           {
  //             "children": [
  //               {
  //                 "title": "1.LETTER - A",
  //                 "type": "directory"
  //               },
  //                {
  //                 "title": "2.LETTER - B",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "3.LETTER - C",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "4.LETTER - D",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "5.LETTER - E",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "6.LETTER - F",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "7.LETTER - G",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "8.LETTER - H",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "9.LETTER - I",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "10.LETTER - J",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "11.LETTER - K",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "12.LETTER - L",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "13.LETTER - M",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "14.LETTER - N",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "15.LETTER - O",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "16.LETTER - P",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "17.LETTER - Q",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "18.LETTER - R",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "19.LETTER - S",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "20.LETTER - T",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "21.LETTER - U",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "22.LETTER - V",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "23.LETTER - W",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "24.LETTER - X",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "25.LETTER - Y",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "26.LETTER - Z",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "COVER PAGE",
  //                 "type": "directory"
  //               }
  //             ],
  //             "title": "COURSE_BOOK",
  //             "type": "directory"
  //           },
  //           {
  //             "children": [
  //               {
  //                 "title": "WORKSHEETS",
  //                 "type": "directory"
  //               }
  //             ],
  //             "title": "WORK_BOOK",
  //             "type": "directory"
  //           }
  //         ],
  //         "title": "ENGLISH",
  //         "type": "directory"
  //       },
  //       ],
  //       "title": "English",
  //       "type": "directory"
  //     },
  //     {
  //         "children": [
  //           {
  //             "children": [
  //               {
  //                 "title": "1.BIG AND SMALL",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "2.TALL AND SHORT",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "3.LONG AND SHORT",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "4.MORE OR LESS",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "5.SHAPES",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "6.ONE - 1",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "7.TWO - 2",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "8.THREE -3",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "9.FOUR - 4",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "10.FIVE - 5",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "11.SIX - 6",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "12.SEVEN - 7",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "13.EIGHT - 8",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "14.NINE - 9",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "15.ZERO - 0",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "16.TEN - 10",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "17.NUMBERS 11 TO 20",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "18.REVISION",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "CONTENT PAGE",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "HOME PAGE",
  //                 "type": "directory"
  //               }
  //             ],
  //             "title": "COURSE_BOOK",
  //             "type": "directory"
  //           },
  //           {
  //             "children": [
  //               {
  //                 "title": "WORKSHEETS",
  //                 "type": "directory"
  //               }
  //             ],
  //             "title": "WORK_BOOK",
  //             "type": "directory"
  //           }
  //         ],
  //         "title": "MATHS",
  //         "type": "directory"
  //       },
  //     {
  //         "children": [
  //           {
  //             "children": [
  //               {
  //                 "title": "1.MYSELF",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "2.MY BODY",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "3.MY FEELINGS",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "4.MY FAMILY",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "5.MY SCHOOL",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "6.MY CLASS",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "7.CLOTHES WE WEAR",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "8.FOOD WE EAT",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "9.FRUITS",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "10.VEGETABLES",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "11.ANIMALS",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "12.BIRDS",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "13.FLOWERS",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "14.VEHICLES",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "15.INSECTS",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "16.COLOURS",
  //                 "type": "directory"
  //               },
  //               {
  //                 "title": "COVER PAGE",
  //                 "type": "directory"
  //               }
  //             ],
  //             "title": "COURSE_BOOK",
  //             "type": "directory"
  //           },
  //           {
  //             "children": [
  //               {
  //                 "title": "WORKSHEETS",
  //                 "type": "directory"
  //               }
  //             ],
  //             "title": "WORK_BOOK",
  //             "type": "directory"
  //           }
  //         ],
  //         "title": "EVS",
  //         "type": "directory"
  //       },
  //     {
  //       "children": [],
  //       "title": "GK",
  //       "type": "directory"
  //     },
  //     {
  //       "children": [],
  //       "title": "COMPUTER",
  //       "type": "directory"
  //     },
  //     {
  //       "children": [],
  //       "title": "TELUGU",
  //       "type": "directory"
  //     },
  //     {
  //       "children": [],
  //       "title": "HINDI",
  //       "type": "directory"
  //     },
  //    {
  //           "children": [
  //             {
  //               "children": [
  //                 {
  //                   "title": "1.COLOUR THE APPLE",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "2.COLOUR THE BALL",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "3.COLOUR THE BOAT",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "4.COLOUR THE CATTERPILLAR",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "5.COLOUR THE CUP",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "6.COLOUR THE DRUM",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "7.COLOUR THE DUCK",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "COLOURING BOOK",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "COVERPAGE",
  //                   "type": "directory"
  //                 }
  //               ],
  //               "title": "COLOURING",
  //               "type": "directory"
  //             }
  //           ],
  //           "title": "ART",
  //           "type": "directory"
  //         },
  //    {
  //           "children": [
  //             {
  //               "children": [
  //                 {
  //                   "title": "1.HOME SWEET HOME",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "2.LEAF BUTTERFLY",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "3.CATERPILLAR BOOKMARK",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "4.BALLOON PENCIL CAP",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "5.BUNNY TABLE TOP STAND",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "6.DRESSING UP",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "7.ZEBRA MASK",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "8.DELIGHTFUL DINO",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "9.CLOWN CURTAIN HOLDER",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "10.FINGER PUPPET DUCK",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "11.BUBBLY BUTTON FISH",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "12.ICE CREAM STICKS CHRISTMAS TREE",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "13.FORK PAINTING CHICK",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "14.SHAPES TRAIN",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "15.BLOW FISH",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "16.BUNNY HEAD GEAR",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "17.CD MOUSE",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "18.CLAY FRUITS",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "19.LOVELY FLOWER CRAFT",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "20.RUBBER BAND TORTOISE",
  //                   "type": "directory"
  //                 },
  //                 {
  //                   "title": "21.PRETTY STRAW NECKLACE",
  //                   "type": "directory"
  //                 },
  //               ],
  //               "title": "ACTIVITY_BOOK",
  //               "type": "directory"
  //             }
  //           ],
  //           "title": "CRAFT",
  //           "type": "directory"
  //         },
    
  //   ],
  //   "title": "FONDATIONAL",
  //   "type": "directory"
  // },
  //   {
  //   "children": [
  //     {
  //       "children": [],
  //       "title": "English",
  //       "type": "directory"
  //     },
  //     {
  //       "children": [],
  //       "title": "MATHS",
  //       "type": "directory"
  //     },
  //     {
  //       "children": [],
  //       "title": "EVS",
  //       "type": "directory"
  //     },
  //     {
  //       "children": [],
  //       "title": "GK",
  //       "type": "directory"
  //     },
  //     {
  //       "children": [],
  //       "title": "COMPUTER",
  //       "type": "directory"
  //     },
  //     {
  //       "children": [],
  //       "title": "TELUGU",
  //       "type": "directory"
  //     },
  //     {
  //       "children": [],
  //       "title": "HINDI",
  //       "type": "directory"
  //     },
  //     {
  //       "children": [],
  //       "title": "ART",
  //       "type": "directory"
  //     },
  //     {
  //       "children": [],
  //       "title": "CRAFT",
  //       "type": "directory"
  //     },
    
  //   ],
  //   "title": "PREPARATORY",
  //   "type": "directory"
  // },
   {
    "children": [
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
     
      
     
    
    
    ],
    // "title": "Foundational Classes KG - LKG - UKG - 1 - 2",
        "title": "ALL",
    "type": "directory"
  },
  {
    "children": [
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
     
      
     
    
    
    ],
    "title": "Foundational  KG - LKG - UKG - 1 - 2",
    "type": "directory"
  },
   {
    "children": [
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
     
     
    
    
    ],
        "title": "Preparatory  3 - 4 - 5",
    "type": "directory"
  },
    {
    "children": [
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
     
    
    ],
    // "title": "Middle Classes",
        "title": "Middle  6 - 7 - 8",
    "type": "directory"
  },
  {
    "children": [
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
      {
        "children": [],
        "title": "",
        "type": "directory"
      },
     
    
    ],
    // "title": "Secondary Classes",
        "title": "Secondary  9 - 10 - 11 - 12",
    "type": "directory"
  },
 
  
 
   
 
  
  
 
 
]
// .concat(menuItemsMakers) we are hidding this line from above line it was like this ].concat(menuItemsMakers)  but we are hidding bz it was showing in all icons